(() => {
  if (customElements.get('sxs-matching-set')) return;
  let pending = false;
  let sourceProduct = '';
  let modalOpener = null;
  let lastAddTrigger = null;
  let requestNumber = 0;
  const modal = document.querySelector('.sxs-matching-modal');
  const drawer = document.querySelector('.sxs-cart-drawer');
  const drawerContent = drawer?.querySelector('.widget_shopping_cart_content');

  function populateModal(markup) {
    if (!modal) return false;
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const offer = parsed.querySelector('sxs-matching-set');
    if (!offer) return false;
    offer.querySelectorAll('[data-matching-product]').forEach((card) => {
      if (!card.dataset.matchingSources.split(/\s+/).includes(sourceProduct)) card.remove();
    });
    if (!offer.querySelector('[data-matching-product]')) return false;
    offer.classList.remove('sxs-matching-set--drawer');
    offer.classList.add('sxs-matching-set--modal');
    offer.querySelector('.sxs-matching-set__heading')?.remove();
    offer.querySelectorAll('[id]').forEach((element) => { element.id = element.id.replace('drawer-', 'modal-'); });
    offer.querySelectorAll('[for]').forEach((element) => { element.htmlFor = element.htmlFor.replace('drawer-', 'modal-'); });
    const content = modal.querySelector('[data-matching-modal-content]');
    content.replaceChildren(offer);
    content.scrollTop = 0;
    return true;
  }

  async function readCartMarkup(cartUrl) {
    const response = await fetch(`${cartUrl}?view=json&_=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) throw new Error('refresh_failed');
    const markup = await response.text();
    if (!markup.includes('sxs-cart-drawer__items')) throw new Error('refresh_failed');
    return markup;
  }

  async function showMatchingModal(productId) {
    if (!modal?.showModal || !productId) return;
    const currentRequest = ++requestNumber;
    const opener = lastAddTrigger || document.activeElement;
    try {
      const cartUrl = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart` : '/cart';
      const markup = await readCartMarkup(cartUrl);
      if (currentRequest !== requestNumber) return;
      sourceProduct = String(productId);
      if (!populateModal(markup)) return;
      modalOpener = opener;
      drawer?.querySelector('.widget-close')?.click();
      modal.querySelector('[role="status"]').textContent = '';
      if (!modal.open) modal.showModal();
      document.body.classList.add('sxs-matching-modal-open');
      modal.querySelector('h2').focus();
      window.baselThemeModule?.gl_currency?.();
    } catch (_) {
      // The normal cart remains available if recommendations cannot be loaded.
    }
  }

  if (modal) {
    document.addEventListener('click', (event) => {
      if (event.target instanceof Element) {
        const trigger = event.target.closest('.ajax_form_cart, .ajax_add_to_cart');
        if (trigger) lastAddTrigger = trigger;
      }
    }, true);
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        modal.close();
      }
    });
    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-matching-close]')) modal.close();
      if (event.target === modal) {
        const bounds = modal.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) modal.close();
      }
    });
    modal.addEventListener('close', () => {
      document.body.classList.remove('sxs-matching-modal-open');
      if (modalOpener?.isConnected && !modalOpener.closest('.sxs-cart-drawer')) modalOpener.focus();
      else document.querySelector('#shopify_add_to_cart, .cart-widget-opener a')?.focus();
    });
    // Legacy product and quick-add forms use jQuery. Companion adds use fetch,
    // so adding inside this dialog updates its offers without opening another.
    const connect = () => {
      if (!window.jQuery) return;
      window.jQuery(document).on('ajaxSuccess.sxsMatchingSet', (_event, xhr, settings) => {
        const url = new URL(settings.url, window.location.origin);
        if (url.origin !== window.location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return;
        const result = xhr.responseJSON;
        const added = result?.items?.[0] || result;
        showMatchingModal(added?.product_id);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
    else connect();
  }

  class MatchingSet extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', (event) => this.updateVariant(event), options);
      this.addEventListener('submit', (event) => this.addCompanion(event), options);
      const cards = this.querySelector('.sxs-matching-set__cards');
      const controls = this.querySelectorAll('[data-matching-scroll]');
      if (this.classList.contains('sxs-matching-set--drawer')) return;
      const updateControls = () => {
        const overflow = cards.children.length > 4 && cards.scrollWidth > cards.clientWidth + 1;
        const position = Math.abs(cards.scrollLeft);
        controls.forEach((control) => {
          control.hidden = !overflow;
          control.disabled = control.dataset.matchingScroll === '-1'
            ? position <= 1 : position + cards.clientWidth >= cards.scrollWidth - 1;
        });
      };
      this.addEventListener('click', (event) => {
        const control = event.target.closest('[data-matching-scroll]');
        if (!control) return;
        const rtl = getComputedStyle(cards).direction === 'rtl';
        cards.scrollBy({ left: Number(control.dataset.matchingScroll) * (rtl ? -1 : 1) * cards.clientWidth * .8, behavior: 'instant' });
      }, options);
      cards.addEventListener('scroll', updateControls, options);
      this.resizeObserver = new ResizeObserver(updateControls);
      this.resizeObserver.observe(cards);
      updateControls();
    }
    disconnectedCallback() { this.controller.abort(); this.resizeObserver?.disconnect(); }

    updateVariant(event) {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement)) return;
      const option = select.selectedOptions[0];
      const card = select.closest('[data-matching-product]');
      if (!card || !option?.value) return;
      card.querySelector('[data-matching-price]').textContent = option.dataset.price;
      const image = card.querySelector('.sxs-matching-set__image');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      card.querySelector('[data-matching-error]').hidden = true;
    }

    async addCompanion(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('[data-matching-form]')) return;
      event.preventDefault();
      if (pending || !form.reportValidity()) return;
      pending = true;
      const inModal = Boolean(this.closest('.sxs-matching-modal'));
      const button = form.querySelector('button[type="submit"]');
      const error = form.querySelector('[data-matching-error]');
      const originalLabel = button.textContent;
      const cartUrl = this.dataset.cartUrl;
      const addedMessage = this.dataset.added;
      let added = false;
      button.disabled = true;
      button.textContent = this.dataset.adding;
      error.hidden = true;
      if (drawerContent) {
        drawerContent.inert = true;
        drawerContent.setAttribute('aria-busy', 'true');
      }
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${form.action}.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form),
        });
        if (!response.ok) throw new Error('add_failed');
        added = true;
        if (window.location.pathname.replace(/\/$/, '') === cartUrl.replace(/\/$/, '')) {
          window.location.reload();
          return;
        }
        const [markup, cartResponse] = await Promise.all([
          readCartMarkup(cartUrl), fetch(`${cartUrl}.js`, { cache: 'no-store' }),
        ]);
        if (!cartResponse.ok || !drawerContent) throw new Error('refresh_failed');
        const cart = await cartResponse.json();
        drawerContent.innerHTML = markup;
        document.querySelectorAll('.cartCount').forEach((count) => { count.textContent = cart.item_count; });
        const subtotal = drawerContent.querySelector('.sxs-cart-drawer__total .amount');
        if (subtotal) document.querySelectorAll('.basel-cart-subtotal > span').forEach((total) => { total.innerHTML = subtotal.innerHTML; });
        drawerContent.inert = false;
        if (inModal && modal.open) {
          if (populateModal(markup)) {
            modal.querySelector('[role="status"]').textContent = addedMessage;
            modal.querySelector('h2').focus();
          } else {
            modal.close();
            document.querySelector('.cart-widget-opener a')?.click();
          }
        } else if (document.body.classList.contains('basel-cart-opened')) {
          (drawerContent.querySelector('.sxs-matching-set__heading') || drawer.querySelector('.widget-close'))?.focus();
        }
        window.baselThemeModule?.gl_currency?.();
        window.Shopify?.StorefrontExpressButtons?.initialize?.();
        drawer.dispatchEvent(new CustomEvent('sxs:cart-added', { detail: { message: addedMessage } }));
      } catch (_) {
        if (added) { window.location.assign(cartUrl); return; }
        error.textContent = this.dataset.error;
        error.hidden = false;
      } finally {
        pending = false;
        this.removeAttribute('aria-busy');
        if (drawerContent) { drawerContent.inert = false; drawerContent.removeAttribute('aria-busy'); }
        if (button.isConnected) {
          button.disabled = false;
          button.textContent = originalLabel;
          if (modal?.open || document.body.classList.contains('basel-cart-opened')) button.focus();
        }
      }
    }
  }
  customElements.define('sxs-matching-set', MatchingSet);
})();
